import { LoadingStatus } from '../types'

export enum BookingSteps {
  Welcome,
  Age,
  Diagnosis,
  Insurance,
  ParentInfo,
  Provider,
  TimeSlots,
  CallNowConfirmation,
  CallLaterConfirmation,
  NotQualified
}

interface BookingFlowData {
  currentStep: BookingSteps
  stepsNumber: number
  currentUtcTime?: string
  timeSlots?: number[]
  dateFrom?: number
  dateTo?: number
}

export interface NavigationState {
  step: BookingSteps
}

export interface BookingInputData {
  zipCode?: string
  isZipCodeSupported?: IsZipCodeSupported
  age?: ChildAges
  diagnosisUserAnswer?: string
  isDiagnosed?: IsDiagnosed
  isInsured?: IsInsured
  provider?: string
  firstName?: string
  lastName?: string
  fullName?: string
  email?: string
  phone?: string
  smsOptout?: boolean
  timeZoneOffset?: string
  timeZoneAbbreviation?: string
  timeSlot?: string
  bookingType?: string
}

export interface BookingABTestsData {
  testVariantIdLocationFilter: TestVariantsIdsLocationFilter
}

export interface BookingState {
  createLeadStatus: LoadingStatus
  status: LoadingStatus
  flowData: BookingFlowData
  inputData: BookingInputData
  abTestsData: BookingABTestsData
  error: string
  createLeadError: string
}

export enum BookingInputFieldsNames {
  zipCode = 'zipCode',
  isZipCodeSupported = 'isZipCodeSupported',
  age = 'age',
  diagnosisUserAnswer = 'diagnosisUserAnswer',
  isDiagnosed = 'isDiagnosed',
  isInsured = 'isInsured',
  provider = 'provider',
  firstName = 'firstName',
  lastName = 'lastName',
  fullName = 'fullName',
  email = 'email',
  phone = 'phone',
  smsOptout = 'smsOptout',
  timeZoneOffset = 'timeZoneOffset',
  timeZoneAbbreviation = 'timeZoneAbbreviation',
  timeSlot = 'timeSlot',
  bookingType = 'bookingType'
}

export enum IsZipCodeSupported {
  Yes = 'true',
  No = 'false'
}

export enum ChildAges {
  YRS_0_3 = '0-3yrs',
  YRS_4_7 = '4-7yrs',
  YRS_8_9 = '8-9yrs',
  YRS_MORE_10 = '10+yrs'
}

export enum IsDiagnosed {
  Yes = 'yes',
  No = 'no',
  Unknown = 'unknown'
}

export enum IsInsured {
  Yes = 'yes',
  No = 'no'
}

export enum NotQualifyingReasons {
  Age = 'age',
  Location = 'location'
}

export enum TestVariantsIdsLocationFilter {
  Undetermined = 'undetermined',
  Control = 0,
  Test = 1
}

// Actions
export interface SetTimeSlotsAction {
  dateFrom: number
  dateTo: number
  timeSlots?: number[]
}
